module.exports = __webpack_public_path__ + "static/media/natour_medium.ff50cd6a.webp";